<template>
  <my-footer @move="move"></my-footer>
</template>

<script>
export default {
  methods: {
    move(c) {
      this.$emit('move', c)
    }
  }
}
</script>
